import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class ProductApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/product');
  }

  async search(query: any, page: number, size: number, meta: MetaQuery | undefined): Promise<any> {
    try {
      const response = await axiosInstance.post(
        `${this.baseURL}/search?page=${page}&size=${size}`,
        query,
      );

      const transformedResults = this.transformList(response.data.data.results);

      if (response.data.data.facets) {
        return {
          results: transformedResults,
          facets: response.data.data.facets,
        };
      }

      return transformedResults;
    } catch (error) {
      console.error(`Error fetching products by query:`, error);
      throw error;
    }
  }

  async getById(productId: string): Promise<any> {
    try {
      const response = await axiosInstance.get(`${this.baseURL}/${productId}`);
      return this.transformNode(response.data.data);
    } catch (error) {
      console.error(`Error fetching product by ID ${productId}:`, error);
      throw error;
    }
  }

  async groupStyles(lkStyleNumbers: Array<string>, targetProductId?: number): Promise<any> {
    const response = await axiosInstance.post(`${this.baseURL}/group`, {
      lkStyleNumbers,
      targetProductId,
    });
    return response.data.data;
  }

  async ungroupStyles(productId: number, lkStyleNumbers?: Array<string>): Promise<any> {
    const response = await axiosInstance.post(`${this.baseURL}/ungroup`, {
      productId,
      lkStyleNumbers,
    });
    return response.data.data;
  }
}

export default ProductApiClient;
